module.exports = __webpack_public_path__ + "static/img/ic_refresh_bg.9db1188.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic_refresh_bg.png
// module id = 51yl
// module chunks = 1